import React, { useCallback } from 'react';
import {
  useFormWatch,
  useFieldController,
} from '../../../../../helpers/formManager';
import { getDisabledDateForPicker } from '../../../shared/packages/dateTime';
import Field from '../../../shared/ui/Field';
import { createPickerSetting, usePickerSettings } from './utils';
import GridLayout from '../../../shared/ui/GridLayout';

const START_LABEL = 'Начальная дата';
const END_LABEL = 'Конечная дата';

const labels = [START_LABEL, END_LABEL];

const DateRangeField = ({ pickerSettings, disabled, className }) => {
  return (
    <GridLayout minWidth="120px" gap="30px" adaptive className={className}>
      {pickerSettings.map((setting, index) => (
        <BaseDatePicker
          key={index}
          label={labels[index]}
          disabled={disabled}
          {...setting}
        />
      ))}
    </GridLayout>
  );
};

DateRangeField.createPickerSetting = createPickerSetting;
DateRangeField.usePickerSettings = usePickerSettings;

export default DateRangeField;

function BaseDatePicker({
  label,
  isFrom = false,
  controllerProps,
  watchProps,
  disabled,
  getDisabledDate,
}) {
  const observableVal = useFormWatch(watchProps);

  const { field, fieldState } = useFieldController(controllerProps);

  const disabledDate = useCallback(
    (date) => {
      if (typeof getDisabledDate === 'function') {
        return (
          getDisabledDate(date) ||
          getDisabledDateForPicker(
            isFrom ? date : observableVal,
            isFrom ? observableVal : date
          )
        );
      }

      return getDisabledDateForPicker(
        isFrom ? date : observableVal,
        isFrom ? observableVal : date
      );
    },
    [observableVal, isFrom, getDisabledDate]
  );

  return (
    <Field.Memoized
      type={Field.types.datePicker}
      formItemLabel={label}
      required={Boolean(controllerProps?.rules?.required)}
      errorMessage={fieldState.error?.message}
      disabledDate={disabledDate}
      value={field.value}
      onChange={field.onChange}
      disabled={disabled}
    />
  );
}
